import FormQuestionAnswerRevisions from "../ApplicationPolicy/formQuestionAnswerRevisions";
import ModalWrapper from '../../helpers/modalWrapper';
import { SIZE_LG } from "../../helpers/constants";

const RevisionsModal = (props) => {
    const {
        breachCausationCp,
        closeHistoryModal,
        Store,
        isHistoryModalOpen,
        historyItem,
    } = props;

    return (
        <ModalWrapper
            isOpen={isHistoryModalOpen}
            onClose={closeHistoryModal}
            size={SIZE_LG}
            modalTestId={`revision-modal-${historyItem.values.machineName}`}
            buttonTestId={`revision-modal-close-button-${historyItem.values.machineName}`}
        >
            <FormQuestionAnswerRevisions
                breachCausationCpOptions={breachCausationCp.options}
                solicitorGroupWorkSources={Store.solicitorGroupWorkSources}
                historyItem={historyItem}
                application={Store.selectedApplication}
            />
        </ModalWrapper>
    )
};

export default RevisionsModal;